import React from "react";
import "./Setting.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/actions/authActions";
import { getProjects } from "../../Redux/actions/projectsActions";
import { Profile_show } from "../../assets/icons";

export default function Setting({ isSettingOpen, setIsSettingOpen }) {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutHandler = () => {
    dispatch(logout(() => navigate("/")));
    dispatch(getProjects("logout"));
  };
  
  return (
    <>
      {isSettingOpen === true && (
        <div className={`modal ${isSettingOpen ? "open" : ""}`}>
          <div className="modal-overlay" onClick={() => setIsSettingOpen(false)}></div>
          <div className="modal-content">
            <div className="" style={{display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center",}}>
              <span className="close-button" onClick={() => setIsSettingOpen(false)}>&#10005;</span>
              <div className="mt-4"><img src={Profile_show} alt="" style={{ width: "150px", margin: "auto" }} /></div>              
              <div className="user-details">
                <p className="capitalize FontFamily-Avenir text-base">{userInfo?.firstName} {userInfo?.lastName}</p>
                <p className="pb-3 text-xs">{userInfo?.email}</p>
              </div>
              <div className="logout_divv"><button className="logout_btn Syne700" onClick={logoutHandler}>Logout</button></div>

              <div style={{width: "100%", border: "1px solid #696978", margin: ".8rem auto", opacity: 0.9,}}></div>

              <div className="">
                <div className="other_sub_div"><Link to="/account-settings">Account Settings</Link></div>

                {/* <div className="other_sub_div"><a rel="noopener noreferrer" href={"https://www.scrollx.io/"} target="_blank">Get support+help</a></div> */}
                {/* <div className="other_sub_div"><Link to={'/dashboard/price'}>Pricing</Link></div> */}

                <div className="other_sub_div">
                  <a rel="noopener noreferrer" href={"https://www.scrollx.io/"} target="_blank">About us</a>
                </div>

                <div className="other_sub_div">
                  <a rel="noopener noreferrer" href={"https://www.scrollx.io/"} target="_blank">Contact us</a>                 
                </div>

                <div className="other_sub_div mb-4"><button onClick={()=>window.open(`/help`)}>Help</button></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}